import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Image } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledBottomAdornment = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-top: 0.6rem;
`;

export const StyledFileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
`;

export const StyledChooseFileContainer = styled.div`
  flex-basis: 29.8rem;
`;

export const StyledFilePlaceholder = styled.div`
  padding: 0.7rem 1.2rem 0.7rem 1.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border.dropdown};
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme }) => theme.colors.background.secondary};
`;

export const StyledLocalFileName = styled.span<{ filename: string }>`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme, filename }) => (filename ? 'inherit' : theme.colors.grey[400])};
`;

export const StyledFileBrowseButton = styled(Button)`
  background: ${({ theme }) => theme.colors.button.close.background};
`;

export const StyledFileUploadIcon = styled(FontAwesomeIcon)`
  && {
    height: 1.4rem;
    width: 1.4rem;
  }
`;

export const StyledRoomAvatarImg = styled(Image)<{ isDarkMode: boolean }>`
  height: 9.6rem;
  width: 9.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
  border: 0.3rem solid
    ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.secondary.lighter : theme.colors.grey[600])};
  object-fit: cover;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
export const StyledRoomBannerImg = styled(Image)<{ isDarkMode: boolean }>`
  height: 10rem;
  width: 38rem;
  border-radius: ${({ theme }) => theme.radius.small};
  border: 0.3rem solid
    ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.secondary.lighter : theme.colors.grey[600])};
  object-fit: cover;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;

export const StyledRandomAvatarButtonContainer = styled.div`
  display: block;
  margin-top: 1.6rem;
`;

export const StyledButtonContainer = styled.div`
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.6rem;
`;

export const InputContainer = styled.div`
  position: relative;
  flex: 1;
`;

export const ClearButton = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  color: ${({ theme }) => theme.colors.grey[400]};
  &:hover {
    color: ${({ theme }) => theme.colors.error.main};
  }
`;
